import PageLogin from "./PageLogin";
const PageLoginCont = () => {
  return (
    <>
      <div className="flex shadow flex-col justify-center items-center h-96">
        <h2 className="text-sm font-bold bg-red-200 p-4 ">Login Required !</h2>
        <PageLogin />
      </div>
    </>
  );
};
export default PageLoginCont;
